<template>
  <div>
    <div v-if="isWishListTicketLoading" class="send-from-all-gift__area">
      <SmallLoading />
    </div>
    <div v-else class="send-from-all-gift__area">
      <div class="send-from-all-gift__header">
        <div class="send-from-all-gift__title subhead-bold">
          すべてのギフトから探す
        </div>
        <div class="send-from-all-gift__explanation">
          ほしいものリストに登録されていないギフトも{{ nickname }}
          さんに贈ることができます
        </div>
        <ButtonPrimary
          class="send-from-all-gift__button"
          text="ギフトを贈る"
          @click-primary-button="clickSendFromAllGiftButton"
        />
      </div>
    </div>
    <TextModalWithSecondary
      v-if="isModalActive"
      :title-text="'作成中のギフトカードがあります'"
      :caption-text="'作成できるカードは１つまでです。\n内容を破棄して新規作成しますか?'"
      :primary-button-text="'新規作成する'"
      :secondary-button-text="'カードを確認する'"
      :cancel-button-text="'閉じる'"
      @clicked-modal-cover="closeModal"
      @clicked-primary="sendFromAllGift"
      @clicked-secondary="moveToGiftCardEditPage"
      @clicked-cancel="closeModal"
    />
  </div>
</template>

<script>
import SmallLoading from '../../../atoms/loadings/SmallLoading.vue'
import ButtonPrimary from '../../../molecules/buttons/ButtonPrimary.vue'
import TextModalWithSecondary from '../../../molecules/modals/with_secondary/text-modal-with-secondary.vue'

import axios from 'axios'

export default {
  components: {
    SmallLoading,
    ButtonPrimary,
    TextModalWithSecondary
  },
  props: {
    isApp: {
      type: Boolean,
      required: true
    },
    nickname: {
      type: String,
      require: false,
      default: ''
    },
    screenName: {
      type: String,
      require: false,
      default: ''
    },
    isWishListTicketLoading: {
      type: Boolean,
      require: true,
      default: false
    },
    isDifferentUserAsGiftCardRecipient: {
      type: Boolean,
      require: true,
      default: false
    }
  },
  data() {
    return {
      isModalActive: false
    }
  },
  methods: {
    closeModal() {
      this.isModalActive = false
    },
    moveToGiftCardEditPage() {
      location.href = '/gift_card/edit'
      this.isModalActive = false
    },
    clickSendFromAllGiftButtonForApp() {
      location.href = `/gift_card/edit?wish_list_screen_name=${this.screenName}`
    },
    clickSendFromAllGiftButton() {
      if (this.isApp) {
        this.clickSendFromAllGiftButtonForApp()
      } else {
        if (this.isDifferentUserAsGiftCardRecipient) {
          this.isModalActive = true
        } else {
          this.sendFromAllGift()
        }
      }
    },
    async sendFromAllGift() {
      try {
        const result = await axios.post(
          '/api/v1/pickup/gift_card_sessions/create_from_wish_list',
          { screen_name: this.screenName }
        )
        const path_params = result.data.wish_list_user_changed
          ? 'wish_list_changed=true'
          : ''
        location.href = `/gift_card/edit?${path_params}`
      } catch (error) {
        this.$emit('send-from-all-gift-error', error)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.send-from-all-gift {
  &__area {
    margin-top: 16px;
    background-color: $white;
    padding: 24px 0;
  }

  &__header {
    padding: 0 16px;
    margin: auto;
    max-width: $small-contents-width;
  }

  &__title {
    @extend %subhead-bold;
    text-align: left;
  }

  &__explanation {
    @extend %caption;
    margin-top: 8px;
    text-align: left;
  }

  &__button {
    margin-top: 24px;
  }
}
</style>
